import React, { useState } from 'react';
import { Button } from '@sm/wds-react';
import { defineMessages, T } from '@sm/intl';
import SeatRequestModal from '../../../SeatRequestModal';

const COPY = defineMessages({
  SEAT_REQUEST: {
    id: 'SeatUpgradeButton.SeatRequest',
    defaultMessage: 'REQUEST POWER SEAT',
    description:
      '[Type: Label][Vis.: high] - This is a button for users to request a seat upgrade.',
  },
});

const SeatUpgradeButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        data-testid="Addon__SeatUpgradeBtn"
        color="alt"
        size="sm"
        disabled={showModal}
        onClick={() => {
          setShowModal(true);
        }}
      >
        <T desc={COPY.SEAT_REQUEST} />
      </Button>
      <SeatRequestModal
        show={showModal}
        onClose={() => setShowModal(false)}
        sourceCategoryKey="global_header"
      />
    </>
  );
};

export default SeatUpgradeButton;
